import _sortBy from 'lodash/sortBy';

import { UserPresence } from 'components/presence/reducers/presence';

export const sortPresence = (presence: UserPresence[]): UserPresence[] =>
  _sortBy(presence, [
    function (element) {
      const rank = {
        working: 1,
        acw: 2,
        away: 3,
        offline: 4,
        unknown: 5,
      };
      return rank[element.presence.status];
    },
    function (element) {
      return element.user.name != null ? element.user.name.toLowerCase() : '';
    },
  ]);
